import Ambassador from 'actions/ambassador';

export default Ambassador.createReducer();
